import confetti from 'canvas-confetti';
import { notifications } from '@mantine/notifications';
import { achievementsStore } from './achievementsStore';
import { ACHIEVEMENTS } from './achievements';

// Unlocks an achievement (idempotent): first time only, persist it, pop a small toast + confetti.
// Re-calling for an already-unlocked id is a no-op, so trackers can fire it freely.
export function notifyAchievement(id: string): void {
    if (achievementsStore.has(id)) return;
    const def = ACHIEVEMENTS.find((a) => a.id === id);
    if (!def) return;

    achievementsStore.unlock(id);
    // zIndex above the Mantine modal (default 200) — an unlock can fire while a modal is open.
    confetti({ particleCount: 50, spread: 60, origin: { y: 0.8 }, scalar: 0.9, zIndex: 10000 });
    notifications.show({
        title: `🏆 Achievement Unlocked: ${def.title}`,
        message: `${def.emoji} ${def.desc}`,
        color: 'yellow',
    });
}
